export default {
    completionForm: 'PROFILE_COMPLETION_FORM',
    educations: 'GET_EDUCATIONS',
    description: 'GET_DESCRIPTION',
    photo: 'GET_PHOTO',
    recommendations: 'GET_RECOMMENDATIONS',
    linkedinResume: 'GET_LINKEDIN_RESUME',
    seniority: 'GET_SENIORITY',
    reasons: 'GET_REASONS',
    profileDescriptionRule: 'GET_PROFILE_DESCRIPTION_RULE',
    experienceDescriptionRule: 'GET_EXPERIENCE_DESCRIPTION_RULE',
    educationDescriptionRule: 'GET_EDUCATION_DESCRIPTION_RULE',
    experiences: 'GET_EXPERIENCES',
    activityAreas: 'GET_ACTIVITY_AREAS',
    hasLoadedAllData: 'GET_HAS_LOADED_ALL_DATA',
    isLoading: 'GET_IS_LOADING_DATA',
};
